import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IGame, IGameAttendancesVotes, IPlayerGame } from "@grassrootly/api";

export interface GameState {
  games: { [key: number]: IGame };
  nextGames: IPlayerGame[],
  featuredGame: IPlayerGame | null;
  previousGames: IPlayerGame[],
  latestGameId: number | null;
  gameVotes: { [key: number]: IGameAttendancesVotes[] };
}

const initialState: GameState = {
  games: {},
  nextGames: [],
  featuredGame: null,
  previousGames: [],
  latestGameId: null,
  gameVotes: {},
};

const gamesSlice = initReducer({
  name: "games",
  initialState,
  reducers: {
    setGames: (state: GameState, action: PayloadAction<IGame[]>) => {
      const mapedGames: any = {};
      action.payload.forEach((g) => {
        mapedGames[g.id] = g;
      });
      state.games = { ...state.games, ...mapedGames };
    },
    setGame: (state: GameState, action: PayloadAction<IGame>) => {
      state.games = { ...state.games, [action.payload.id]: action.payload };
    },
    // TODO [up]: To be removed
    setLatestGame: (state: GameState, action: PayloadAction<number>) => {
      state.latestGameId = action.payload;
    },
    setNextGames: (state: GameState, action: PayloadAction<IPlayerGame[]>) => {
      action.payload.sort((a, b) => {
        // sort games in ascending order
        return (a.game_datetime as string) > (b.game_datetime as string) ? 1 : (a.game_datetime as string) < (b.game_datetime as string) ? -1 : 0;
      });
      state.nextGames = action.payload;
    },
    setFeaturedGame: (state: GameState, action: PayloadAction<IPlayerGame | null>) => {
      state.featuredGame = action.payload;
    },
    setPreviousGames: (state: GameState, action: PayloadAction<IPlayerGame[]>) => {
      action.payload.sort((a, b) => {
        // sort games in descending order
        return (a.game_datetime as string) < (b.game_datetime as string) ? 1 : (a.game_datetime as string) > (b.game_datetime as string) ? -1 : 0;
      });
      state.previousGames = action.payload;
    },
    setGameVotes: (state: GameState, action: PayloadAction<{ gameId: number; votes: IGameAttendancesVotes[] }>) => {
      state.gameVotes = { ...state.gameVotes, [action.payload.gameId]: action.payload.votes };
    },
    cleanState: () => {
      return initialState;
    }
  },
});

const persistConfig: PersistConfig<GameState> = {
  key: "games",
  whitelist: ["latestGameId", "nextGames", "previousGames"],
  storage: AsyncStorage,
};

export const gameActions = gamesSlice.actions;

export default createPersistReducer(persistConfig, gamesSlice.reducer);
